(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["beam-hero-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('beam-hero-videos')) {
    customElements.define('beam-hero-videos', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const track = () => this.querySelector('.bvh__track');
        const move = (direction) => {
          const row = track();
          if (!row) return;
          const card = row.querySelector('deferred-media,.video-placeholder-wrapper');
          const step = (card?.getBoundingClientRect().width || row.clientWidth) + (parseFloat(getComputedStyle(row).gap) || 0);
          row.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.sync = () => {
          const row = track();
          if (!row) return;
          this.querySelector('[data-bvh-step="-1"]')?.toggleAttribute('disabled', row.scrollLeft < 2);
          this.querySelector('[data-bvh-step="1"]')?.toggleAttribute('disabled', row.scrollLeft + row.clientWidth >= row.scrollWidth - 2);
        };
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-bvh-step]');
          if (button && this.contains(button)) move(Number(button.dataset.bvhStep));
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.target !== track() || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.addEventListener('scroll', this.sync, { ...options, capture:true, passive:true });
        this.addEventListener('shopify:block:select', (event) => {
          const row = track();
          const card = event.target.closest('deferred-media,.video-placeholder-wrapper');
          if (row && card?.parentElement === row) row.scrollTo({ left:row.scrollLeft + card.getBoundingClientRect().left - row.getBoundingClientRect().left, behavior:'auto' });
        }, options);
        this.resize = new ResizeObserver(this.sync);
        this.resize.observe(this);
        this.mutations = new MutationObserver(this.sync);
        this.mutations.observe(this, { childList:true, subtree:true });
        this.setAttribute('data-ready','');
        this.sync();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.mutations?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
